/*
 * Pinzelli — product-blocks.js
 * Comportements des blocs custom de la page produit :
 *  - <product-videos>      : galerie vidéo verticale "pvb" + modale de lecture
 *  - <product-composition> : dépliant "bcd" des détails de composition
 *  - <product-share>       : bouton de partage (Web Share API + copie du lien)
 */

if (!customElements.get('product-videos')) {
  customElements.define('product-videos', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-pvb-card]'));
      this.modal = this.querySelector('.pvb-modal');
      this.modalVideo = this.modal ? this.modal.querySelector('.pvb-modal-video') : null;
      this.closeButton = this.modal ? this.modal.querySelector('.pvb-modal-close') : null;
      if (!this.cards.length || !this.modal) return;

      this.sources = this.cards.map(function (card) {
        var video = card.querySelector('video');
        if (!video) return null;
        return {
          poster: video.getAttribute('poster') || '',
          sources: Array.prototype.map.call(video.querySelectorAll('source'), function (s) {
            return { src: s.getAttribute('src'), type: s.getAttribute('type') };
          })
        };
      });

      var self = this;
      this.cards.forEach(function (card, index) {
        if (!self.sources[index]) return;
        card.addEventListener('click', function (event) { event.preventDefault(); self.open(index); });
        card.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); self.open(index); }
        });
      });
      if (this.closeButton) this.closeButton.addEventListener('click', function () { self.close(); });
      this.modal.addEventListener('click', function (event) { if (event.target === self.modal) self.close(); });
      this.onKeydown = function (event) {
        if (event.key === 'Escape' && self.modal.classList.contains('is-open')) self.close();
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.style.overflow = '';
    }

    load(index) {
      var data = this.sources[index];
      if (!this.modalVideo || !data) return;
      this.modalVideo.pause();
      while (this.modalVideo.firstChild) this.modalVideo.removeChild(this.modalVideo.firstChild);
      data.sources.forEach(function (source) {
        var el = document.createElement('source');
        el.src = source.src;
        if (source.type) el.type = source.type;
        this.modalVideo.appendChild(el);
      }, this);
      if (data.poster) this.modalVideo.poster = data.poster;
      this.modalVideo.load();
      var playing = this.modalVideo.play();
      var self = this;
      if (playing && playing.catch) {
        playing.catch(function () {
          self.modalVideo.muted = true;
          self.modalVideo.play().catch(function () { /* lecture bloquée */ });
        });
      }
    }

    open(index) {
      this.load(index);
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (this.closeButton) this.closeButton.focus();
    }

    close() {
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.modalVideo) this.modalVideo.pause();
    }
  });
}

if (!customElements.get('product-composition')) {
  customElements.define('product-composition', class extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('[data-bcd-root]');
      this.button = this.querySelector('[data-bcd-toggle]');
      if (!this.root || !this.button) return;
      var self = this;
      this.button.addEventListener('click', function () {
        var isOpen = self.root.classList.toggle('open');
        self.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  });
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.feedback = this.querySelector('[data-share-feedback]');
      if (!this.button) return;
      var self = this;
      this.button.addEventListener('click', function () {
        var url = self.getAttribute('data-share-url') || window.location.href;
        var title = self.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () { /* annulé */ });
          return;
        }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { self.notify(); });
        }
      });
    }
    notify() {
      if (!this.feedback) return;
      this.feedback.removeAttribute('hidden');
      var self = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () { self.feedback.setAttribute('hidden', ''); }, 2500);
    }
  });
}
